/**
 * 欧洲国家： [德国、法国、意大利、荷兰、比利时、卢森堡、爱尔兰、西班牙、葡萄牙、奥地利、
 * 芬兰、立陶宛、拉脱维亚、爱沙尼亚、斯洛伐克、斯洛文尼亚、希腊、马耳他、塞浦路斯、
 * 瑞典、挪威、冰岛、丹麦、法罗群岛、俄罗斯、乌克兰、摩尔多瓦、波兰、捷克、匈牙利、
 * 瑞士、列支敦士登、英国、摩纳哥、罗马尼亚、保加利亚、塞尔维亚、北马其顿、阿尔巴尼亚、
 * 克罗地亚、黑山、波斯尼亚和黑塞哥维那、梵蒂冈、圣马力诺、安道尔、直布罗陀]
 * 欧洲国家货币
 *
 * - `EUR` 欧元（德国、法国、意大利、荷兰、比利时、卢森堡、爱尔兰、西班牙、葡萄牙、奥地利
 * 、芬兰、立陶宛、拉脱维亚、爱沙尼亚、斯洛伐克、斯洛文尼亚、希腊、马耳他、塞浦路斯、摩纳哥,黑山
 * ，梵蒂冈,圣马力诺,安道尔）
 * -  瑞典克朗
 * - `NOK` 挪威克朗
 * -  冰岛克朗
 * - `DKK` 丹麦克朗 KR
 * 法罗群岛
 * 俄罗斯
 * 乌克兰
 * 摩尔多瓦
 * 波兰
 * - `CZK` 捷克克朗
 * 匈牙利
 * - `CHF` 瑞士法郎\列支敦士登
 * - `GBP` 英镑
 * 罗马尼亚
 * 保加利亚
 * 塞尔维亚
 * 北马其顿
 * 阿尔巴尼亚
 * -克罗地亚
 * 波斯尼亚和黑塞哥维那
 */
//
//  export const RESTAURANT_CURRENCY = [
//     {
//         label: 'EUR €',
//         value: '€',
//     },
//     {
//         label: 'SEK kr',
//         value: 'Kr',
//     },
//     {
//         label: 'NOK kr',
//         value: 'Nkr',
//     },
//     {
//         label: 'Krona ISK',
//         value: 'ISK',
//     },
//     {
//         label: 'DKK kr',
//         value: 'kr',
//     },
//     {
//         label: 'FIK kr',
//         value: 'kr',
//     },
//     {
//         label: 'Br ₽',
//         value: '₽',
//     },
//     {
//         label: 'Hryvnia ₴',
//         value: '₴',
//     },
//     {
//         label: 'MDL Leu',
//         value: 'Leu',
//     },
//     {
//         label: 'złote ₴',
//         value: '₴',
//     },
//     {
//         label: 'CZK Kč',
//         value: 'Kč',
//     },
//     {
//         label: 'HUF Ft',
//         value: 'Ft',
//     },
//     {
//         label: 'CHF CHF',
//         value: 'CHF',
//     },
//     {
//         label: 'GBP ￡',
//         value: '￡',
//     },
//     {
//         label: 'Leu romacircnesc ROL',
//         value: 'ROL',
//     },
//     {
//         label: 'Bulgarian Lev',
//         value: 'Lev',
//     },
//     {
//         label: 'динар RSD',
//         value: 'RSD',
//     },
//     {
//         label: 'Denar ден',
//         value: 'ден',
//     },
//     {
//         label: 'Albanian Lek',
//         value: 'Lek',
//     },
//     {
//         label: 'Kuna',
//         value: 'Kn',
//     },
//     {
//         label: 'CONVERTIBLE MARK',
//         value: 'BAM',
//     }
// ];
export const RESTAURANT_CURRENCY = [
    {
        label: '€',
        value: '€',
    },
    {
        label: 'kr',
        value: 'kr',
    },
    {
        label: 'ISK',
        value: 'ISK',
    },
    {
        label: '₽',
        value: '₽',
    },
    {
        label: '₴',
        value: '₴',
    },
    {
        label: 'Leu',
        value: 'Leu',
    },
    {
        label: 'Kč',
        value: 'Kč',
    },
    {
        label: 'Ft',
        value: 'Ft',
    },
    {
        label: 'CHF',
        value: 'CHF',
    },
    {
        label: '￡',
        value: '￡',
    },
    {
        label: 'ROL',
        value: 'ROL',
    },
    {
        label: 'Lev',
        value: 'Lev',
    },
    {
        label: 'RSD',
        value: 'RSD',
    },
    {
        label: 'ден',
        value: 'ден',
    },
    {
        label: 'Lek',
        value: 'Lek',
    },
    {
        label: 'Kn',
        value: 'Kn',
    },
    {
        label: 'BAM',
        value: 'BAM',
    }
];
